import { HealthcareSessionId, HealthcareUserId } from '@hc-frontend/core-types';
import { z } from 'zod';

export const HandleContextualTrafficUseCaseParameters = z.object({
  sessionId: HealthcareSessionId,
  userId: HealthcareUserId,
});

export type HandleContextualTrafficUseCaseParameters = z.infer<
  typeof HandleContextualTrafficUseCaseParameters
>;
